import React, { useState, useContext } from "react";

import { ALL_GL_MAIN_ACCOUNTS_QUERY } from "../../../graphql/GLMainAccounts/GLMainAccounts.graphql";

import {
  AddGLMainAccountForm,
  EditGLMainAccountForm
} from "../../../components/GLMainAccounts";
import { ModalContext } from "../../../components/ModalProvider";

import DataTable from "../../../components/DataTable";

import PageHeader from "../../../components/PageHeader";

import { COLUMNS } from "./columns";

import GLMainAccountFilters from "./GLMainAccountFilters";
import { getFilterState, saveFilterState } from "../../../utils";

const GeneralLedgerAccountsPage = () => {
  const INITIAL_FILTER_STATE = getFilterState("ACCOUNT_FILTERS", {
    Active: true
  });
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);

  const handleSetFilters = inputs => {
    console.log(inputs);
    saveFilterState("ACCOUNT_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const { setModalOpen } = useContext(ModalContext);
  const resetFilters = () => handleSetFilters({ Active: true });

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={GLMainAccountFilters}
        columns={COLUMNS}
        filters={filters}
        name="GLMainAccounts"
        query={ALL_GL_MAIN_ACCOUNTS_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Accounts"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddGLMainAccountForm onComplete={() => setModalOpen(false, "")} />
          )
        }
      />
      <DataTable
        columns={COLUMNS}
        dataQuery={ALL_GL_MAIN_ACCOUNTS_QUERY}
        initialSortBy={[
          { id: "MainAccountId", desc: false },
          { id: "Type", desc: true }
        ]}
        name="GLMainAccount"
        where={filters}
        onRowClick={data =>
          setModalOpen(
            true,
            <EditGLMainAccountForm
              account={data}
              onComplete={() => setModalOpen(false, "")}
            />
          )
        }
      />
    </React.Fragment>
  );
};
GeneralLedgerAccountsPage.propTypes = {};
export default GeneralLedgerAccountsPage;
